<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .change {
    @include mixins.body2();
    display: flex;
    align-items: center;
    gap: utils.in_rem(8px);
  }

  .changes {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
  }
</style>

<script>
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  export let changes;
</script>

<div class="changes">
  {#each changes as change}
    {@const name = change?.name || ""}
    {@const firstName = name.split(" ")[0]}
    {@const lastName = name
      .split(" ")
      .filter((_, i) => i > 0)
      .join(" ")}
    {@const src = change?.photo}

    <div class="change">
      <Avatar {firstName} {lastName} {src} />
      {name}
      {#each ["description", "secondaryDescription"] as key}
        {#if change[key]}
          <Icon class="fa-arrow-right" size="xs" />
          {change[key]}
        {/if}
      {/each}
    </div>
  {/each}
</div>
